import useAuth from 'src/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { useDonorOnboardingComplete } from 'src/hooks/corporate-onboarding/useOnboardingRequests';

/**
 * Checks if the current user is able to create a donation or food run. (In the
 * case that they would normally would be able to. For example, they are an
 * admin but their organization has been disabled).
 *
 * @param {'donation' | 'food-run'} type Type of creation, used for the reason string
 * @returns {[boolean, string|null]} Returns a tuple of [disabled, reason]
 */
export default function useCreateDonationDisabled(type) {
  const { t } = useTranslation('translation');

  const { user } = useAuth();
  const businessIsActive = !!user.is_business_visible_to_others;
  const { complete } = useDonorOnboardingComplete();

  let disabled = false;
  let reason = null;
  if (!businessIsActive) {
    disabled = true;
    reason =
      type == 'donation'
        ? t('sidebar.organization-disabled', {
            context: 'donation',
          })
        : t('sidebar.organization-disabled', {
            context: 'food-run',
          });
  } else if (!complete && !user.is_non_profit) {
    disabled = true;
    reason = t('corporate-onboarding.onboarding-required-error');
  }

  return [disabled, reason];
}
